import React, { useEffect, useState } from "react"
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

// Build library of icons
library.add(fas)

// Helper
import { bodyRequest } from "@helpers/javascript/javascript"
import { rememberEntity } from "@react/helpers/entity_filter"

// Components
import { SalesTable }   from "./SalesTable"
import { SalesFilters } from "./SalesFilters"
import { TopTypes }     from "./TopTypes"
import { YearTotal }    from "./YearTotal"
import { MonthPrev }    from "./MonthPrev"

const CLIENT = 'by_client'

const SalesStatistics = ({
  url,
  years,
  types,
  months,
  previous,
  currency,
  fiscalYearStartMonth,
  currentFiscalYear,
  encodingName,
  partnerFilter
}) => {
  const [loading, setLoading] = useState(true)
  const [data,    setData]    = useState({})
  const [filters, setFilters] = useState({ 
                                  type: CLIENT, 
                                  year: currentFiscalYear,
                                  previous: previous[0],
                                  partner: partnerFilter?.selected || ""
                                })
  
  useEffect(() => {
    setLoading(true)
    const body = { query: filters }
    if (partnerFilter) rememberEntity(partnerFilter.param, filters.partner)
    bodyRequest({ url, body }).then(response => {
      setData(response.sales)
      setLoading(false)
    })
  }, [filters])

  return (
    <>
      <SalesFilters
        years                 = { years }
        previous              = { previous }
        types                 = { types }
        filters               = { filters }
        setFilters            = { setFilters }
        fiscalYearStartMonth  = { fiscalYearStartMonth }
        data                  = { data }
        months                = { months }
        currency              = { currency }
        encodingName          = { encodingName }
        partnerFilter         = { partnerFilter }
      />
      <SalesTable data = { data } months = { months } types = { types } loading = { loading } currency = { currency } />
      <TopTypes   data = { data } types = { types } type = { filters.type } currency = { currency } />
      <MonthPrev  data = { data } loading = { loading } currency = { currency } filters = { filters } />
      <YearTotal  data = { data.props_year_total } currency = { currency } fiscalYearStartMonth = { fiscalYearStartMonth } />
    </>    
  )
}
export default SalesStatistics